import bandwidthTo from "@/filters/bandwidth-to.filter";
import capitalize from "@/filters/capitalize.filter";
import emptyTo from "@/filters/empty-to.filter";
import enumTo from "@/filters/enum-to.filter";
import optionText from "@/filters/option-text.filter";
import datetime from "@/filters/datetime.filter";
import applianceTypeTo from "@/filters/appliance-type-to.filter";
import internetStatusTo from "@/filters/internet-status-to.filter";
import message from "@/filters/message.filter";
import bandwidthToBps from "@/filters/bandwidth-to-bps.filter";
import date from "@/filters/date.filter";
import cloudServiceMenuTo from "@/filters/cloud-service-menu-to.filter";
import riskTo from "@/filters/risk-to.filter";

import type { App } from "vue";

export const AppFilter = {
  emptyTo,
  capitalize,
  optionText,
  enumTo,
  bandwidthTo,
  date,
  datetime,
  applianceTypeTo,
  internetStatusTo,
  message,
  bandwidthToBps,
  cloudServiceMenuTo,
  riskTo,
};

export default {
  install: (app: App<Element>) => {
    app.config.globalProperties.$filter = AppFilter;
  },
};
